export const homeUrl = window.location.origin;
export let environment = "";
export let secrectSettlementUrl = "";
export let centrelLoggerUrl = "";
export let baseUrl = "";


export const leadSquaredUrl = "https://ws.stoxbox.in:9016/stxgeneralapi/Lead.Capture"
export const initialLeadSuqaredUrl = leadSquaredUrl;
export const leadSquaredGetUserApi = "https://stoxboxapi.bpwealth.com/paytm_subscription/api/v1/RetrieveLeadByPhoneNumber?accessKey=u%24r9c9db741eb460c8cdb619022561ee561&secretKey=060b66eb4faa350ce9da82263f9d46990b3aae32&phone=";
export const reqBody = {
  "username": "pgcoreengine",
  "password": "FI754-WD035-DL262-HY772-HX311"
};

export const whatNext = [{
  "step": 1,
  "title": " Fill Your Details",
  "width": 3.5
},
{
  "step": 2,
  "title": " Make Payment",
  "width": 3.5
},
{
  "step": 3,
  "title": "Download StoxBox App",
  "width": 5
}];

export const states = [
  'Andhra Pradesh',
  'Arunachal Pradesh',
  'Assam',
  'Bihar',
  'Chhattisgarh',
  'Goa',
  'Gujarat',
  'Haryana',
  'Himachal Pradesh',
  'Jharkhand',
  'Karnataka',
  'Kerala',
  'Madhya Pradesh',
  'Maharashtra',
  'Manipur',
  'Meghalaya',
  'Mizoram',
  'Nagaland',
  'Odisha',
  'Punjab',
  'Rajasthan',
  'Sikkim',
  'Tamil Nadu',
  'Telangana',
  'Tripura',
  'Uttar Pradesh',
  'Uttarakhand',
  'West Bengal',
  'Others',
];

if (window.location.search.includes("env=dev") || window.location.origin.includes("activity1.stoxbox.in") || window.location.origin.includes("activity.stoxbox.in:9003") || window.location.origin.includes("http://localhost")) {
  baseUrl = "https://channel1.stoxbox.in:9001";
  centrelLoggerUrl = "https://channel1.stoxbox.in:9001/centralapi/log-write"
  secrectSettlementUrl = "https://channel1.stoxbox.in:9001/stxsubs/noauth";
  environment = "dev";
} else {
  centrelLoggerUrl = "https://channel1.stoxbox.in:9001/centralapi/log-write";
  baseUrl = "https://channel1.stoxbox.in:9001";
  secrectSettlementUrl = "https://channel1.stoxbox.in:9001/stxsubs/noauth";
  environment = "prod";
}
